import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  iconButton: {
    cursor: 'pointer',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    '&:hover, &:focus-visible': {
      backgroundColor: 'rgba(202, 202, 252, 0.3)',
    },
  },
  activeWrapper: {
    position: 'relative',
    display: 'inline-flex',
    '&::after': {
      content: '""',
      position: 'absolute',
      inset: '2px',
      border: '3px solid #ffd0d0',
      borderRadius: '5px',
      pointerEvents: 'none',
    },
  },
}));
